<template>
    <div class="m-fiscanPackageStats">

        <el-row :gutter="20" class="mt10">
            <el-col :span="24">
                <stats-chart
                    ref="knowledgeChart"
                    type="pie"
                    title="知识点"
                    height="420px"
                ></stats-chart>
            </el-col>
        </el-row>

        <el-row :gutter="20" class="mt10">
            <el-col :span="12">
                <stats-chart
                    ref="deviceChart"
                    type="pie"
                    title="采集设备"
                ></stats-chart>
            </el-col>

            <el-col :span="12">
                <stats-chart
                    ref="identifyChart"
                    type="pie"
                    title="职鉴图像比重"
                ></stats-chart>
            </el-col>
        </el-row>

        <el-row :gutter="20" class="mt10">
            <el-col :span="12">
                <stats-chart
                    ref="tipChart"
                    type="pie"
                    title="TIP数量"
                ></stats-chart>
            </el-col>

            <el-col :span="12">
                <stats-chart
                    ref="safeChart"
                    type="pie"
                    title="空包比重"
                ></stats-chart>
            </el-col>

        </el-row>
    </div>
</template>

<script>
import StatsChart from "@/components/Statistics/StatsChart"

export default {
    components: {
        StatsChart
    },

    data() {
        return {}
    },

    mounted() {
        this.getChartData()
    },

    methods: {
        getChartData() {
            this.$api.fiscanPackageStatsByKnowledge().then(res => {
                const data = res.package

                data.innerRing = data.innerRing.filter(item => item.value !== 0)
                data.outerRing = data.outerRing.filter(item => item.value !== 0)

                const options = {
                    data,
                    showLegend: true,
                    legend: {
                        type: 'plain',
                        right: 20,
                    },
                    series: [
                        {
                            radius: [0, '40%'],
                        },
                        {
                            radius: ['50%', '70%'],
                        }
                    ]
                }
                this.$refs.knowledgeChart.drawChart(options)
            })

            this.$api.fiscanPackageStatsByProduct().then(res => {
                const data = res.package
                const options = {
                    data,
                }
                this.$refs.deviceChart.drawChart(options)
            })

            this.$api.fiscanPackageStatsByIdentification().then(res => {
                const data = res.package.map(item => {
                    if (item.isIdentification) {
                        item.name = '职鉴图像'
                    } else {
                        item.name = '非职鉴图像'
                    }
                    return item
                })
                const options = {
                    data,
                    name: '数量',
                    isRing: true
                }
                this.$refs.identifyChart.drawChart(options)
            })

            this.$api.fiscanPackageStatsByTipCount().then(res => {
                const data = res.package
                const options = {
                    data,
                }
                this.$refs.tipChart.drawChart(options)
            })

            this.$api.fiscanPackageStatsByEmpty().then(res => {
                const data = res.package.map(item => {
                    if (item.isEmptyPercentage) {
                        item.name = '空包'
                    } else {
                        item.name = '非空包'
                    }
                    return item
                })
                const options = {
                    data,
                    name: '数量',
                    isRing: true
                }
                this.$refs.safeChart.drawChart(options)
            })
        },
    },
}
</script>

